// SPDX-License-Identifier: AGPL-3.0-or-later

import KonvoLogoAsset from '@app/media/images/konvo-logo-flat.svg?react';

interface KonvoLogoProps {
	size?: number;
}

export function KonvoLogo({size = 16}: KonvoLogoProps) {
	return <KonvoLogoAsset width={size} height={size} aria-hidden="true" style={{flexShrink: 0}} />;
}
